









































import { mapGetters } from 'vuex'
import ListFilters from '@/components/ListFilters.vue'
import DateRangePicker from '@/components/DateRangePicker.vue'
import AddressTypeAhead from '../../marketplace/components/AddressTypeAhead.vue'
import {
  MarketplaceLocation,
  prepareLocationData,
  prepareSelectedLocation
} from '../../marketplace/marketplace-location'

export default {
  components: { ListFilters, DateRangePicker, AddressTypeAhead },
  computed: {
    ...mapGetters(['assignmentsFilters']),
    initialFilterValues() {
      const {
        reference,
        pickupRangeStart,
        pickupRangeEnd,
        pickupPlaceId,
        dropOffPlaceId,
        pickupLocationName,
        dropOffLocationName
      } = this.assignmentsFilters || {}
      return {
        reference,
        pickupRange: {
          pickupRangeStart,
          pickupRangeEnd
        },
        pickupLocation: prepareLocationData(pickupPlaceId, pickupLocationName),
        dropOffLocation: prepareLocationData(dropOffPlaceId, dropOffLocationName)
      }
    }
  },
  methods: {
    prepareLocation(location: MarketplaceLocation): Array<MarketplaceLocation> {
      return prepareSelectedLocation(location)
    }
  }
}
